import React, { useCallback } from "react"
import Button from "@mui/material/Button";
import Box from "@mui/material/Box"
import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import { requestMemberComponentsSync } from "../../usefuls/helpers";
import { AIModalOpenAction } from "../../store/Matters/mattersSlice";
import AIModal from "./AIModal";
import DeleteSweepIcon from "@mui/icons-material/DeleteSweep";

const sxHandler = (first) => {
    const marginLeft = !!first ? {} : { ml: "10px" }
    return {
        color: "black.200",
        border: "1px solid #C0C0C0",
        ...marginLeft
    }
}
const sectionAddFuncAttributeVal = {
    note: { note: { id: Math.random(), value: "" }},
    commentList: { commentList: [{ id: Math.random(), value: "" }]},
    list: { list: [{ id: Math.random(), value: "" }]},
    phrase: { phrase: { id: Math.random(), value: "" }},
    annexure: { annexure: { id: Math.random(), value: { lettersInpVal: "", titleVal: "" } }},
    dialog: { dialog: { id: Math.random(), members: [], dialogValues: [{whoSad: "", whatSad: ""}]} }
}

const CustomAnswerList = ({ componentIndex = 0, answerList, answerId, going_next, staticSection, ...customProps }) => {
    const dispatch = useDispatch();
    const handleOpen = _ => dispatch(AIModalOpenAction(true))
    const { matterId } = useParams();
    const addSectionHandler = useCallback((value) => {
        const updatedData = [...answerList]
        updatedData.splice(componentIndex + 1 ?? 1, 0 , value)
        requestMemberComponentsSync(
            {
                customProps,
                matterId,
                updatedData,
                answerId,
                dispatch,
                going_next,
                staticSection
            }
        )
    }, [answerId, answerList, componentIndex, customProps, dispatch, going_next, matterId, staticSection])
    const removeSectionHandler = useCallback(() => {
        const updatedData = [...answerList].filter((_ , listIndex) => listIndex !== componentIndex)
        requestMemberComponentsSync(
            {
                customProps,
                matterId,
                updatedData,
                answerId,
                dispatch,
                going_next,
                staticSection
            }
        )
    }, [answerId, answerList, componentIndex, customProps, dispatch, going_next, matterId, staticSection])

    const {
        note: attrNote,
        commentList: attrCommentList,
        list: attrList,
        phrase: attrPhrase,
        annexure: attrAnnexure,
        dialog: attrDialog
    } = sectionAddFuncAttributeVal

    return (
        <Box display="flex" mt="10px">
            <Button onClick={() => addSectionHandler(attrNote)} sx={sxHandler(true)}>
                Note
            </Button>
            <Button onClick={() => addSectionHandler(attrCommentList)} sx={sxHandler()}>
                Comment list
            </Button>
            <Button onClick={() => addSectionHandler(attrList)} sx={sxHandler()}>
                List
            </Button>
            <Button onClick={() => addSectionHandler(attrDialog)} sx={sxHandler()}>
                Dialog
            </Button>
            <Button onClick={() => addSectionHandler(attrPhrase)} sx={sxHandler()}>
                Phrase
            </Button>
            <Button onClick={() => addSectionHandler(attrAnnexure)} sx={sxHandler()}>
                Annexure
            </Button>
            {componentIndex !== 0 && (
                <Button onClick={removeSectionHandler} sx={{ color: "white", backgroundColor: "error.dark", ml: "10px" }}>
                    <DeleteSweepIcon color="inherit" cursor="pointer" />
                </Button>
            )}
            <Button onClick={handleOpen} sx={{ color: "white", backgroundColor: "primary.main", ml: "100px" }}>
                Use AI
            </Button>
            <AIModal />
        </Box>
    )
}

export default CustomAnswerList;